import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Trans } from 'react-i18next';

const AdminSubHeader = ({
    breadcrumbs = [],
    title,
    subtitle,
    badge = null,
    children
}) => {
  return (
      <div className="m-subheader px-0 pb-8">
        <div className="d-flex align-items-center">
          <div className="mr-auto">
            <h3
                className={
                  breadcrumbs
                      ? 'm-subheader__title m-subheader__title--separator'
                      : 'm-subheader__title'
                }
            >
              <Trans>{title}</Trans>{" "}
              {subtitle}{" "}
              {badge && (<span className="m-badge m-badge--danger m-badge--wide">{badge}</span>)}
            </h3>
            {breadcrumbs && (
                <ul className="m-subheader__breadcrumbs m-nav m-nav--inline">
                  <li className="m-nav__item m-nav__item--home">
                    <Link
                        to="/dashboard"
                        className="m-nav__link m-nav__link--icon"
                    >
                      <i className="m-nav__link-icon la la-home" />
                    </Link>
                  </li>

                  {breadcrumbs.map((item, i) => [
                    <li className="m-nav__separator" key={'separator' + i}>
                      -
                    </li>,
                    <li className="m-nav__item" key={'item' + i}>
                      <Link to={item.to} className="m-nav__link">
                      <span className="m-nav__link-text">
                        <Trans>{item.title}</Trans>
                      </span>
                      </Link>
                    </li>
                  ])}
                </ul>
            )}
          </div>
          {children && <div>{children}</div>}
        </div>
      </div>
  );
}

AdminSubHeader.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  badge: PropTypes.string,
  breadcrumbs: PropTypes.array,
  'breadcrumbs.map': PropTypes.func,
  children: PropTypes.any
};

export default AdminSubHeader;
